import { GetServerSideProps } from 'next';
import { dehydrate, QueryClient } from 'react-query';

import { InsightService } from 'lib/apis/entity/insight';

export const HousePricesModuleGetServerSideProps: GetServerSideProps = async () => {
  const queryClient = new QueryClient();
  await InsightService.HPILanding.fetchData(queryClient);
  return {
    props: {
      dehydratedState: JSON.stringify(dehydrate(queryClient)),
    },
  };
};